import { Card, CardBody, Button, Divider } from "@heroui/react";
import "./WipSidebar.css";

type Props = {
    brief: string;
    briefStatus: string; // "incomplete" | "partial" | "complete" (o altro)
    keywords: string[];
    currentPhaseIndex: number;
    setCurrentPhaseIndex?: (index: number) => void;
};

const statusLabel: Record<string, string> = {
    incomplete: "Incomplete",
    partial: "Partial",
    complete: "Complete",
};

export const WipSidebar = ({ brief, briefStatus, keywords, currentPhaseIndex, setCurrentPhaseIndex }: Props) => {




    //const keywords = keywords ?? [];

    return (
        <aside className="wipSidebarMock">
            <Card className="wipOuter" shadow="sm">
                <CardBody className="wipOuterBody">
                    <h2 className="wipTitle">Brief Creativo</h2>

                    {/* Panel: Concept */}
                    <section className="wipPanel">
                        <div className="wipPanelHeader">Concept Creativo</div>

                        {brief ? (
                            <p className="wipParagraph">{brief}</p>
                        ) : (
                            <p className="wipParagraph wipPlaceholder">
                                Compila il brief in chat per vedere qui il concept.
                            </p>
                        )}

                        {/*<Button className="wipBtnNeutral" onPress={() => {}}>
                            Modifica
                        </Button>*/}
                    </section>

                    {/* Panel: Parole chiave */}
                    <section className="wipPanel">
                        <div className="wipPanelHeader">Parole chiave</div>

                        <div className="kwGrid">
                            {keywords.length > 0 ? (
                                keywords.map((kw, i) => (
                                    <span className="kwChip" key={`${kw}-${i}`}>
                    <span className="kwSpark" aria-hidden="true">✦</span>
                    <span className="kwText">{kw}</span>
                    {/*<span className="kwX" aria-hidden="true">×</span>*/}
                  </span>
                                ))
                            ) : (
                                <div className="kwEmpty">Le parole chiave appariranno qui.</div>
                            )}

                            {/*<button type="button" className="kwAdd" onClick={() => {}}>
                                <span className="plusCircle" aria-hidden="true">+</span>
                                <span>Aggiungi</span>
                            </button>*/}
                        </div>
                    </section>

                    {/* Status (stile badge mockup, ma guidato da briefStatus) */}
                    <div className="statusWrap">
            <span className={`statusBadge statusBadge--${briefStatus}`}>
              {statusLabel[briefStatus] ?? briefStatus}
            </span>
                    </div>

                    {/* CTA */}
                    {/*<Button className="wipCta" onPress={() => {}}>
                        <span className="ctaIcon" aria-hidden="true">⟳</span>
                        Rigenera Brief
                    </Button>*/}

                    {/* Create a button vai alla Fase 2 that update currentPhaseIndex a 2 */}
                    {currentPhaseIndex < 2 && (
                        <Button
                            className="wipCta"
                            onPress={() => {
                                // Aggiorna currentPhaseIndex a 2
                                setCurrentPhaseIndex && setCurrentPhaseIndex(2);
                            }}
                        >
                            Vai alla Fase 2
                        </Button>
                    )}
                </CardBody>

                <Divider className="wipDivider" />
            </Card>
        </aside>
    );
};
